import { adminAuth, optVerifcation } from "../../services/authService";
import { getVendorById } from "../../services/vendorService";
import { authenticateAction, authenticateAdminAction, logoutAction, updateVendorDetailsAction } from "../actions/authAction";

export const authenticateDispatcher = (data, onFailure = () => { }) => {
    return async (dispatch, getState) => {
        try {
            const resp = await optVerifcation(data);
            if (resp) {
                // toast.success('Logged in successfully!')
                if (resp.payload) {
                    const dataResp = {
                        ...resp.payload,
                    }
                    dataResp.vendorDto.tokenExpiryTimestamp = Date.now() + resp.payload.validation_TIME

                    dispatch(authenticateAction(dataResp));
                }
                else {
                    onFailure(resp.message)
                }
            }
        } catch (error) {
            console.log('==================authenticateDispatcher==================');
            console.log(error);
            console.log('==================authenticateDispatcher==================');
        }
    }
}

export const adminAuthDispatcher = (data, onFailure = () => { }) => {
    return async (dispatch, getState) => {
        try {
            const resp = await adminAuth(data);
            console.log("ADMIN", resp);
            if (resp) {
                let fetchedData = {
                    jwt: resp.access_token,
                    tokenExpiryTimestamp: Date.now() + (resp.expires_in * 1000),
                    refreshToken: resp.refresh_token,
                    user: resp.user,
                    userId: resp.user.id
                }
                fetchedData.permission = JSON.parse("{\"Vendors\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"},\"Admins\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"},\"Plans\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"},\"Roles\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"},\"Reports\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"},\"Dashboard\":{\"canCreate\":\"1\",\"canRead\":\"1\",\"canUpdate\":\"1\",\"canDelete\":\"1\"}}")
                dispatch(authenticateAdminAction(fetchedData));
            }
            else {
                // toast.error('Login failed! Credentials did not match')
                onFailure('Login failed! Credentials did not match')
            }
        } catch (error) {
            console.log('==================adminAuthDispatcher==================');
            console.log(error);
            console.log('==================adminAuthDispatcher==================');
        }
    }
}

export const registerDispatcher = (data, callback = () => { }, showToast = true) => {
    return async (dispatch, getState) => {
        try {
            console.log('showToast', showToast)
            const resp = null;
            if (resp) {
                if (resp.payload) {
                    console.log(resp)
                    // toast.success(resp.message)
                    callback()
                }
            }
        } catch (error) {
            console.log('==================registerDispatcher==================');
            console.log(error);
            console.log('==================registerDispatcher==================');
        }
    }
}

export const socialRegisterDispatcher = (data, callback = () => { }, showToast = true) => {
    return async (dispatch, getState) => {
        try {
            const resp = null;
            // const resp = await createUser(data, showToast);
            if (resp) {
                if (resp.payload) {
                    console.log(resp)
                    // toast.success(resp.message)
                    // dispatch(registerAction(resp.payload));
                }
            }
        } catch (error) {
            console.log('==================socialRegisterDispatcher==================');
            console.log(error);
            console.log('==================socialRegisterDispatcher==================');
        }
        finally {
            callback()
        }
    }
}


export const logoutDispatcher = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(logoutAction());
        } catch (error) {
            console.log('==================registerDispatcher==================');
            console.log(error);
            console.log('==================registerDispatcher==================');
        }
    }
}

export const updateVendorDetailsDispatcher = (vendorId, onSuccess) => {
    return async (dispatch, getState) => {
        let vendor = null;
        try {
            vendor = await getVendorById(vendorId);
        } catch (error) {
            console.log('==================updateVendorDetailsDispatcher==================');
            console.log('ERROR:', error)
            console.error('ERROR:', error)
            console.log('==================updateVendorDetailsDispatcher==================');
        }
        if (vendor) {
            if (vendor.payload) {
                dispatch(updateVendorDetailsAction(vendor.payload))
                if (onSuccess) {
                    onSuccess()
                }
            }
        }
    }
}